<template>
  <div class="service-form">
    <div class="form-header">
      <div class="form-header__title">
        <p class="city">Услуги - {{ city ? city.name : cityId }}</p>
        <p class="service-type">Дополнительные</p>
      </div>
      <div class="form-header__edit">
        <template v-if="userRole === 'admin'">
          <vs-button
            v-if="id"
            color="primary"
            type="filled"
            @click="onEdit">
            <img src="@/assets/icons/check.svg" />
          </vs-button>
          <vs-button
            v-else
            color="primary"
            type="filled"
            @click="onAdd">
            <img src="@/assets/icons/check.svg" />
          </vs-button>
        </template>
      </div>
    </div>

    <div class="form">
      <div class="form__column">

        <div class="form__field">
          <span
            :class="{ 'form__field-label_hidden': !form.name }"
            class="form__field-label form__field-label_select">
            Название
          </span>
          <vs-input
            v-model="form.name"
            :class="{ 'validate-error': errors.has('name') }"
            :disabled="isDisabled"
            class="w-full"
            name="name"
            placeholder="Название"
            v-validate="'required'" />
        </div>

        <div class="photo-block">
          <div class="form__column">
            <div class="form__field">
              <span
                :class="{ 'form__field-label_hidden': form.baseCost === '' || form.baseCost === undefined }"
                class="form__field-label form__field-label_select">
                Базовая стоимость
              </span>
              <vs-input-number
                v-model="form.baseCost"
                :class="{ 'validate-error': errors.has('baseCost') }"
                :disabled="isDisabled"
                class="w-full"
                name="baseCost"
                placeholder="Базовая стоимость"
                v-validate="'required'" />
            </div>
            <div class="form__field">
              <span
                :class="{ 'form__field-label_hidden': form.cleanerCost === '' || form.cleanerCost === undefined }"
                class="form__field-label form__field-label_select">
                Ставка клинера
              </span>
              <vs-input-number
                v-model="form.cleanerCost"
                :class="{ 'validate-error': errors.has('cleanerCost') }"
                :disabled="isDisabled"
                class="w-full"
                name="cleanerCost"
                placeholder="Ставка клинера"
                v-validate="'required'" />
            </div>
          </div>

          <div class="form__column">
            <vs-custom-uploader
              :uploads="form.photo ? [form.photo] : []"
              :limit="1"
              :automatic="true"
              :show-upload-button="false"
              :disabled="isDisabled"
              text="Иконка (высота 60px)"
              image-width="100%"
              fileName="file"
              @file-loaded="setPhotoId"
              @on-delete="deletePhoto" />
          </div>
        </div>

        <div class="form__field_few">
          <div class="form__field">
            <span
              class="form__field-label form__field-label_select">
              Время
            </span>
            <vue-timepicker
              v-model="form.cleanTime"
              :class="errors.has('cleanTime') ? 'validate-error' : ''"
              :disabled="isDisabled"
              name="cleanTime"
              v-validate="'required'" />
          </div>

          <div class="form__field">
            <span
              :class="{ 'form__field-label_hidden': !form.status }"
              class="form__field-label form__field-label_select">
              Статус
            </span>
            <v-select
              v-model="form.status"
              :options="Object.keys(statuses).map(value => ({ value, label: statuses[value] }))"
              :reduce="type => type.value"
              :class="{ 'validate-error': errors.has('status') }"
              :clearable="false"
              :disabled="isDisabled"
              placeholder="Статус"
              label="label"
              name="status"
              v-validate="'required'" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueTimepicker from 'vue2-timepicker'

import vsCustomUploader from '@/components/vsCustomUploader'

export default {
  name: 'ServiceForm',

  components: {
    VueTimepicker,
    vsCustomUploader
  },

  props: {
    id: {
      type: Number,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    cityId: {
      type: Number,
      required: false
    },
    mainServiceId: {
      type: Number,
      required: false
    }
  },

  computed: {
    ...mapGetters({
      userRole: 'user/role'
    }),

    isDisabled() {
      return this.userRole !== 'admin'
    }
  },

  data() {
    return {
      form: {
        cleanTime: { HH: '00', mm: '00', ss: '00' }
      },
      city: {},
      statuses: {
        active: 'Активен',
        unactive: 'Не активен'
      }
    }
  },

  watch: {
    id() {
      this.init()
    },
    cityId() {
      this.getCity()
    }
  },

  mounted() {
    this.init()
    if (this.cityId) {
      this.getCity()
    }
  },

  methods: {
    init() {
      if (this.id) {
        this.fetchService()
      } else {
        this.form = {
          cleanTime: { HH: '00', mm: '00', ss: '00' },
          status: 'active'
        }
      }
    },

    async fetchService() {
      let service = await this.$apiClient.service('services').get(this.id)
      if (service.cleanTime) {
        service.cleanTime = {
          HH: service.cleanTime.split(':')[0],
          mm: service.cleanTime.split(':')[1],
          ss: '00'
        }
      } else {
        service.cleanTime = { HH: '00', mm: '00', ss: '00' }
      }
      this.form = service
    },

    async getCity() {
      this.city = await this.$apiClient.service('cities').get(this.cityId)
    },

    async onAdd() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        this.$vs.notify({
          title: 'Заполните данные верно',
          color: 'warning',
          time: 2500
        })
        return false
      }

      const servicesService = this.$apiClient.service('services')

      let service
      try {
        const data = {
          ...this.form,
          type: this.type,
          cityId: this.cityId,
          cleanTime: `${this.form.cleanTime.HH}:${this.form.cleanTime.mm}`,
        }
        delete data.city
        delete data.photo
        if (this.mainServiceId) {
          data.mainServiceId = this.mainServiceId
        }
        service = await servicesService.create(data)
      } catch (err) {
        this.$vs.notify({
          title: 'Что-то пошло не так при создании услуги',
          text: err.message,
          color: 'danger',
          time: 2500
        })
        return false
      }

      this.$vs.notify({
        title: 'Услуга добавлена',
        color: 'success',
        time: 2500
      })

      this.$emit('close', service)

      // this.$router.push({ name: 'Orders' })
    },

    async onEdit() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        this.$vs.notify({
          title: 'Заполните данные верно',
          color: 'warning',
          time: 2500
        })
        return false
      }

      const servicesService = this.$apiClient.service('services')

      let service
      try {
        const data = {
          ...this.form,
          type: this.type,
          cityId: this.cityId,
          cleanTime: `${this.form.cleanTime.HH}:${this.form.cleanTime.mm}`,
        }
        delete data.city
        delete data.photo
        service = await servicesService.patch(this.form.id, data)
      } catch (err) {
        this.$vs.notify({
          title: 'Что-то пошло не так при изменение услуги',
          text: err.message,
          color: 'danger',
          time: 2500
        })
        return false
      }

      this.$vs.notify({
        title: 'Услуга изменена',
        color: 'success',
        time: 2500
      })

      this.$emit('close', service)

      // this.$router.push({ name: 'Orders' })
    },

    setPhotoId(upload) {
      this.form.photoId = upload[0].id
      this.form.photo = upload[0]
    },

    deletePhoto() {
      this.form.photoId = null
      this.form.photo = null
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/components/serviceForm.scss';
</style>
